import React from "react";
import "./AboutPage.scss";
import Container from "../../shared/ui/Container";
import teamImage from "./team.png";
const AboutPage = () => {
  const testimonials = [
    {
      text: "Working with this team changed how we think about accessibility. Their testing process is thorough, honest, and focused on real users — not just compliance.",
      author: "Samantha R.",
      position: "Product Manager",
    },
    {
      text: "They helped us make our app accessible to everyone without compromising design or performance. The collaboration was seamless and professional.",
      author: "Alex B.",
      position: "UX Lead",
    },
    {
      text: "True experts who care about people as much as they care about results. Our accessibility score improved, and our users noticed the difference.",
      author: "Michael T.",
      position: "Product Manager",
    },
  ];
  return (
    <>
      <section className="about-page page-header" aria-labelledby="page-title">
        <Container>
            <h1 id="page-title" className="page-header__title">
              About Us
            </h1>
            <p className="page-header__subtitle">
              We believe that the web should be accessible to everyone,
              regardless of their abilities or disabilities. We go beyond
              compliance — our mission is to create digital experiences that
              truly empower people.
            </p>
        </Container>
      </section>

      <section className="content-section" aria-labelledby="values-title">
        <h2 id="values-title" className="content-section__title">
          Our Values
        </h2>
        <ul className="values-list">
          <li className="values-list__item">
            <h3 className="values-list__heading">🌍 Meaningful Access</h3>
            <p>
              Every improvement we make helps someone interact, work, and live
              more independently.
            </p>
            <div className="values-list__divider"></div>
          </li>
          <li className="values-list__item">
            <h3 className="values-list__heading">🧠 Smart Accessibility</h3>
            <p>
              We combine human expertise with automation to deliver efficient,
              scalable, and truly reliable accessibility results.
            </p>
            <div className="values-list__divider"></div>
          </li>
          <li className="values-list__item">
            <h3 className="values-list__heading">⚡Simple Solutions</h3>
            <p>
              We make complex accessibility issues understandable, translating
              technical findings into clear, actionable insights for your team.
            </p>
            <div className="values-list__divider"></div>
          </li>
          <li className="values-list__item">
            <h3 className="values-list__heading">🔄 Continuous Evolution</h3>
            <p>
              Accessibility isn’t a one-time fix — we continuously refine our
              methods, tools, and knowledge to stay ahead of changing standards
              and technologies.
            </p>
            <div className="values-list__divider"></div>
          </li>
        </ul>
      </section>

      <section className="content-section" aria-labelledby="team-title">
        <h2 id="team-title" className="content-section__title">
          Our Team
        </h2>
        <div className="content-section__content">
          <p className="content-section__text">
            We are a team of dedicated accessibility professionals who believe
            that technology should be usable by everyone. Our testing is
            performed exclusively on real devices, without relying on simulators
            or shortcuts — because only real-world testing reveals real
            barriers. <br></br>We see deep purpose in what we do. Accessibility
            is not just a requirement — it’s a way to ensure that every person,
            regardless of ability, can experience the full richness of the
            digital world. Everyone deserves to choose from abundance, not
            limitation. We believe in the power of digital accessibility — not
            only because it transforms lives, but because it helps businesses
            grow, reach new audiences, and build trust. <br></br>Our work is
            defined by quality over speed, yet we always deliver on time. Our
            clients value our precision, commitment, and the meaningful impact
            we bring to every project.
          </p>
          <img
            src={teamImage}
            alt="Our Team"
            className="content-section__image"
          />
        </div>
      </section>

      <section className="content-section" aria-labelledby="testimonials-title">
        <h2 className="content-section__title">What Our Clients Say</h2>

        <div className="testimonials-list">
          {testimonials.map((item, index) => (
            <blockquote key={index} className="testimonials-list__item">
              <p className="testimonials-list__text">“{item.text}”</p>
              <p className="testimonials-list__author">
                — {item.author}, <span>{item.position}</span>
              </p>
            </blockquote>
          ))}
        </div>
      </section>
    </>
  );
};

export default AboutPage;
